import React, { memo } from 'react';

import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import PropTypes from 'prop-types';

import {
  TOOLBAR_BUTTON_GROUP_SIZES,
  ToolbarButtonGroupSize,
} from './ToolbarButtonGroupCDS.constants';
import { getToggleButtonGroupStyles, getToggleButtonStyles } from './ToolbarButtonGroupCDS.styles';

const ToolbarButtonGroupCDS = ({
  buttons = [],
  value,
  onChange,
  exclusive = false,
  size = ToolbarButtonGroupSize.MEDIUM,
}) => (
  <ToggleButtonGroup
    exclusive={exclusive}
    size={size}
    sx={getToggleButtonGroupStyles}
    value={value}
    onChange={onChange}
  >
    {buttons.map(({ value: buttonValue, label, icon: Icon, disabled, dataTestId, onClick }) => (
      <ToggleButton
        disableFocusRipple
        disableRipple
        data-testid={dataTestId}
        disabled={disabled}
        key={buttonValue}
        sx={getToggleButtonStyles}
        value={buttonValue}
        onClick={onClick}
      >
        {Icon && <Icon />}
        {label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

ToolbarButtonGroupCDS.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType,
      disabled: PropTypes.bool,
      dataTestId: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  exclusive: PropTypes.bool,
  size: PropTypes.oneOf(TOOLBAR_BUTTON_GROUP_SIZES),
  onChange: PropTypes.func,
};

export default memo(ToolbarButtonGroupCDS);
